import * as React from "react"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { IconButton } from "@mui/material"
import PermsWrapper from "../../Auth/PermsWrapper"
import { permissions } from "../../../../config/constants"

export default function OpportunityActionMenu(props: any) {
  const {
    row,
    setIsDrawerOpen,
    setIsEditGoalsOpen,
    setIsDeleteOpen,
    dateFilterHandler,
    fetchAvailableYears,
  } = props
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ color: "#C1C1C0" }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose()
            setIsDrawerOpen(true)
          }}
          sx={{
            fontSize: "14px",

            color: "#000",
            borderRadius: "4px",
            margin: "10px",

            "&:hover": {
              backgroundColor: "#3366D61A",
            },
          }}
        >
          View Details
        </MenuItem>
        <PermsWrapper perm={permissions.DELETE_OPPORTUNITY}>
          <MenuItem
            onClick={() => {
              handleClose()
              setIsDeleteOpen(true)
            }}
            sx={{
              fontSize: "14px",

              color: "red",
              borderRadius: "4px",
              margin: "10px",

              "&:hover": {
                backgroundColor: "#3366D61A",
              },
            }}
          >
            Delete Opportunity
          </MenuItem>
        </PermsWrapper>
        <MenuItem
          sx={{
            fontSize: "14px",
            color: "#000",
            borderRadius: "4px",
            margin: "10px",
            "&:hover": {
              backgroundColor: "#3366D61A",
            },
          }}
          onClick={async () => {
            handleClose()
            setIsEditGoalsOpen(true)
            await fetchAvailableYears()
            dateFilterHandler(row.original.start_date)
          }}
        >
          Goals
        </MenuItem>
      </Menu>
    </div>
  )
}
